<template lang="pug">
  .wrapper
    el-alert(v-if="showErrMsg" class="alert" :title="errMsg" type="error" @close="() => {showErrMsg = false}")
    el-form(ref="form" :model="form" class="form" size="mini" label-width="60px")
      el-form-item(label="手机号" prop="phoneNumber" class="form-item")
        el-input(v-model="form.phoneNumber")
      //- el-form-item(prop="password" class="form-item")  
      //-   el-input(v-model="form.pwd" type="password" show-password autocomplete="off" @change="submit")
      el-form-item(label="验证码" prop="captcha" class="form-item")
        el-input(v-model="form.captcha" clearable)
          el-button(slot="append" @click="startCountdown" :disabled="countdown!==60")
            .countdown {{countdown!==60 ? countdown : '发送验证码'}}
      el-form-item
        el-button(type="primary", @click="submit") 登录
</template>

<script>
import { setToken, setUsername } from 'utils/storage';
import { debounce } from 'utils';
import { getCaptcha, login } from 'api/user';

export default {
  data() {
    return {
      form: {
        phoneNumber: '',
        captcha: '',
      },
      countdown: 60,
      showErrMsg: false,
      errMsg: '',
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    startCountdown: debounce(async function() {
      this.showErrMsg = false;
      if (!this.form.phoneNumber) {
        this.showErrMsg = true;
        this.errMsg = '请先输入手机号';
      } else {
        const res = await getCaptcha({ phoneNumber: this.form.phoneNumber }).catch(() =>
          this.$message.error('发送验证码失败'),
        );
        if (res.code === 0) {
          const itv = setInterval(() => {
            if (this.countdown !== 0) {
              this.countdown--;
            } else {
              clearInterval(itv);
              this.countdown = 60;
            }
          }, 1000);
        } else {
          this.showErrMsg = true;
          this.errMsg = res.msg;
        }
      }
    }, 200),
    async submit() {
      const { phoneNumber, captcha } = this.form;
      this.showErrMsg = false;
      if (phoneNumber && captcha) {
        const res = await login({ phoneNumber, captcha });
        if (res.code === 0) {
          const setStorage = () => {
            setToken(res.data.token);
            setUsername(phoneNumber);
          };
          const setHeader = () => {
            const $header = window.globalHeader;
            $header.$data.isLogin = true;
            $header.$data.username = phoneNumber;
          };
          setStorage();
          setHeader();
          this.$router.replace({ path: '/' });
        } else {
          this.showErrMsg = true;
          this.errMsg = '验证码不正确';
        }
      } else {
        this.showErrMsg = true;
        this.errMsg = '请输入手机号和验证码';
      }
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  position: relative;
  width: 300px;
  margin: 0 auto;
  .alert {
    position: absolute;
    top: 0;
  }
  .form {
    padding-top: 84px;
    text-align: center;
  }
}
</style>
